/**
 * @ngdoc enum
 * @name mx.shell.ActionFilterType
 * @module mx.shell
 *
 * @description
 * Represents possible Filtering options for actions
 */
export enum ActionFilterType {
	/**
	 * @ngdoc property
	 * @name mx.shell.ActionFilterType#Any
	 *
	 * @description
	 * Filter is not specified
	 */
	Any = 0,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionFilterType#Specified
	 *
	 * @description
	 * Only objects with the specified criteria match the Action
	 */
	Specified = 1,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionFilterType#ExceptSpecified
	 *
	 * @description
	 * Only objects which does not match the specified criteria
	 */
	ExceptSpecified = 2,
}
